module.exports = __webpack_public_path__ + "images/minorBaby_3e22494.svg";